/**
 * Module to get the application version. Page must include an element with id application-data containing the data with version
 */
define('utils/application-data',['jquery'], function($) {
    const applicationData = $('body');

    // Do not display TCU or password update pop-up on the OTP verification page
    const isAccountVerificationPage = window.location.pathname.startsWith("/auth/account-verification/");
    const eula = isAccountVerificationPage || applicationData.data('eula') !== false;
    const changePassword = isAccountVerificationPage || applicationData.data('changePassword') !== false;

    return {
        version: applicationData.data('version'),
        eula: eula,
        changePassword: changePassword
    };
});

